"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.linkClick = void 0;
var consts_1 = require("../consts");
var utils_1 = require("../utils");
var linkClick = function (title, module, url) {
    var data = {
        event: 'linkclick',
        eventInfo: 'linkclick',
        link: {
            linkTitle: title || consts_1.NOT_AVAILABLE,
            linkModule: module || consts_1.NOT_AVAILABLE,
            targetURL: url || consts_1.NOT_AVAILABLE,
        },
    };
    return (0, utils_1.checkDataLayerValueEmpty)(data);
};
exports.linkClick = linkClick;
